import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Gift, Users, Sparkles } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

const ReferralCTA = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleIndicarClick = () => {
    if (user) {
      // Se logado, vai para a página de indicações no painel
      navigate('/indicacoes');
    } else {
      // Se não logado, vai para auth
      navigate('/auth');
    }
    setTimeout(() => window.scrollTo(0, 0), 100);
  };

  return (
    <section id="referral-cta" className="py-12 md:py-16 bg-gradient-to-b from-background via-primary/5 to-background relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-10 w-72 h-72 bg-primary/10 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-10 w-72 h-72 bg-secondary/10 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <motion.div 
          className="text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="relative bg-gradient-to-br from-primary/10 via-secondary/5 to-primary/10 rounded-2xl md:rounded-3xl p-6 md:p-8 lg:p-12 border border-primary/20 shadow-2xl overflow-hidden">
            {/* Decorative background */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-secondary/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-primary/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />
            
            <div className="relative z-10">
              {/* Icons */}
              <div className="flex justify-center gap-3 md:gap-4 mb-4 md:mb-6">
                <motion.div 
                  className="w-12 h-12 md:w-14 md:h-14 bg-gradient-to-br from-primary to-blue-400 rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg"
                  whileHover={{ scale: 1.1, rotate: 5 }}
                >
                  <Gift className="w-6 h-6 md:w-7 md:h-7 text-white" />
                </motion.div>
                <motion.div 
                  className="w-12 h-12 md:w-14 md:h-14 bg-gradient-to-br from-secondary to-orange-400 rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg"
                  whileHover={{ scale: 1.1, rotate: -5 }}
                >
                  <Users className="w-6 h-6 md:w-7 md:h-7 text-white" />
                </motion.div>
                <motion.div 
                  className="w-12 h-12 md:w-14 md:h-14 bg-gradient-to-br from-green-500 to-emerald-400 rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg"
                  whileHover={{ scale: 1.1, rotate: 5 }}
                >
                  <Sparkles className="w-6 h-6 md:w-7 md:h-7 text-white" />
                </motion.div>
              </div>

              <h2 className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold mb-3 md:mb-4 bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent py-1">
                Use mais a AI4ME sem pagar mais
              </h2>
              
              <p className="text-sm md:text-base text-muted-foreground mb-6 md:mb-8 max-w-2xl mx-auto leading-relaxed px-2">
                Indique o AI4ME para empreendedores do seu círculo e receba <strong className="text-primary">30 créditos</strong> por cada cadastro qualificado. Uma oportunidade de crescer — juntos.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                  <Button 
                    size="lg" 
                    className="bg-gradient-to-r from-secondary to-orange-500 text-white hover:from-secondary/90 hover:to-orange-500/90 font-bold text-base md:text-lg px-6 md:px-8 py-5 md:py-6 shadow-lg hover:shadow-xl min-h-[44px] w-full sm:w-auto"
                    onClick={handleIndicarClick}
                  >
                    {user ? 'Indique um amigo' : 'Comece agora'}
                  </Button>
                </motion.div>
              </div>

            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ReferralCTA;
